export default __webpack_public_path__ + "static/media/gorevler-btn.339f4833.svg";